import React from 'react';
import { StyleSheet, View, ScrollView, Appearance, Image, Platform, Keyboard } from 'react-native';
import { router } from 'expo-router';
import { Button, Text, TextInput, Switch } from 'react-native-paper';
import axios from 'axios';
import { MotiView } from 'moti';
import { Skeleton } from 'moti/skeleton';
import { useForm, Controller } from "react-hook-form";
import Select from '../../../components/Select/Select';
import { MainContext } from '../../../contexts/MainContext';
import Spacer from '../../../components/Spacer/Spacer';
import Checkbox from '../../../components/CheckBox/CheckBox';
import ImageUploader from '../../../components/ImageUploader/ImageUploader';
import NumberTextInput from '../../../components/NumberTextInput/NumberTextInput';
import HaveForm from '../../../assets/haveForm.png';

export default function Index() {
  const myContext = React.useContext(MainContext);
  const colorScheme = Appearance.getColorScheme();
  const siteAddsTypes = myContext.addsTypes ? myContext.addsTypes : {transactions:[]};
  const [pageLoading, setPageLoading] = React.useState(true);
  const [addAdsFormActive, setAddAdsFormActive] = React.useState(false);
  const [step, setStep] = React.useState(1);                                                    
  const [experts, setExperts] = React.useState([]);
  const [countries, setCountries] = React.useState([]);
  const [ostan, setOstan] = React.useState([]);
  const [shahrestan, setShahrestan] = React.useState([]);
  const [mantaghe, setMantaghe] = React.useState([]);
  const [bakhsh, setBakhsh] = React.useState([]);
  const [transactions, setTransactions] = React.useState([]);
  const [transactionId, setTransactionId] = React.useState(null);
  const [sellStatus, setSellStatus] = React.useState([]);
  const [landTypes, setLandTypes] = React.useState([]);
  const [transactionsMeta, setTransactionsMeta] = React.useState([]);
  const [landTypesMeta, setLandTypesMeta] = React.useState([]);
  const [landTypesWelfareAmenities, setLandTypesWelfareAmenities] = React.useState([]);
  const [landTypesBranches, setLandTypesBranches] = React.useState([]);
  const [submitLoading, setSubmitLoading] = React.useState(false);
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({});  

  React.useEffect(() => {
    getFristData();
    getMantaghe('6543595e889c4a9ec46580f6');
    if(Object.keys(siteAddsTypes).length > 2) {
      let transactions = [];
      Object.values(siteAddsTypes.transactions).map((item) => {
        transactions.push({key: item._id, value: item.term_name, sell_status: item.sell_status, add_meta_list: item.add_meta_list});
      });
      setTransactions(transactions);

      if(myContext.addAdsForm['transaction']) {
        let targetTransaction = Object.values(transactions).filter((item) => item.key === myContext.addAdsForm['transaction']);
        getSellStatus(targetTransaction[0]);
        if(myContext.addAdsForm['sell_status']) {
          if(targetTransaction[0]?.sell_status) {
            let targetSellStatus = Object.values(targetTransaction[0].sell_status).filter((item) => item._id === myContext.addAdsForm['sell_status']);
            getLandType(targetSellStatus[0]);
            if(myContext.addAdsForm['land_type']) {
              if(targetSellStatus[0]?.land_types) {
                let targetLandTypes = Object.values(targetSellStatus[0].land_types).filter((item) => item._id === myContext.addAdsForm['land_type']);
                getExtraMeta(targetLandTypes[0]);
              }
            }
          }
        }
      }
    }
    // if(myContext.addAdsFormActive) {
    //   setAddAdsFormActive(true);
    // }
  }, [])

  const getFristData = () => {
    setPageLoading(true);
    axios.all([
      axios.get(`/consultants`),
      axios.get(`/get_countries`),
    ])
      .then(axios.spread((consultants, country) => {
        let countryData = [];
        Object.values(country.data).map((item) => {
          countryData.push({key: item._id, value: item.title});
        })
        setCountries(countryData);

        let consultantsData = [];
        Object.values(consultants.data).map((item, i) => {
          consultantsData.push({key: item.id, value: item.name});
        })
        setExperts(consultantsData);

        setPageLoading(false);
      }))
      .catch(myContext.handleAxiosError)
      .finally(() => setPageLoading(false));

    if(myContext.addAdsForm['region']) {
      if(myContext.addAdsForm['region']['country']) {
        getState(myContext.addAdsForm['region']['country']);
      }
      if(myContext.addAdsForm['region']['ostan']) {
        getShahrestans(myContext.addAdsForm['region']['ostan']);
      }
      if(myContext.addAdsForm['region']['shahrestan']) {
        getMantaghe(myContext.addAdsForm['region']['shahrestan']);
      }
      if(myContext.addAdsForm['region']['mantaghe']) {
        getBakhsh(myContext.addAdsForm['region']['mantaghe']);
      }
    }
  }

  const getState = (id) => {
    axios.all([
      axios.get(`/get_ostan/${id}`),
    ])
      .then(axios.spread((ostan) => {
        let data = [];
        Object.values(ostan.data).map((item) => {
          data.push({key: item._id, value: item.title});
        })
        setOstan(data);
      }))
      .catch(myContext.handleAxiosError);
  }

  const getShahrestans = (id) => {
    axios.all([
      axios.get(`/get_shahrestans?ostan=${id}`),
    ])
      .then(axios.spread((shahresten) => {
        let data = [];
        Object.values(shahresten.data).map((item) => {
          data.push({key: item._id, value: item.title});
        })
        setShahrestan(data);
      }))
      .catch(myContext.handleAxiosError);
  }

  const getMantaghe = (id) => {
    axios.all([
      axios.get(`/get_manategh/${id}`),
    ])
      .then(axios.spread((mantaghe) => {
        let data = [];
        Object.values(mantaghe.data).map((item) => {
          data.push({key: item._id, value: item.title});
        })
        setMantaghe(data);
      }))
      .catch(myContext.handleAxiosError);
  }

  const getBakhsh = (id) => {
    axios.all([
      axios.get(`/get_bakhshs/${id}`),
    ])
    .then(axios.spread((bakhsh) => {
      let data = [];
      Object.values(bakhsh.data).map((item) => {
        data.push({key: item._id, value: item.title});
      })
      setBakhsh(data);
    }))
    .catch(myContext.handleAxiosError);
  }

  const getSellStatus = (data) => {
    let sellStatusData = [];
    if(data.sell_status) {
      Object.values(data.sell_status).map((item) => {
        sellStatusData.push({key: item._id, value: item.term_name, land_types: item.land_types});
      })
      setSellStatus(sellStatusData);
    }
    if(data.add_meta_list) {
      setTransactionsMeta(data.add_meta_list);
    }
  }

  const getLandType = (data) => {
    let landtypesData = [];
    if(data.land_types) {
      Object.values(data.land_types).map((item) => {
        landtypesData.push({key: item._id, value: item.term_name, add_meta_list: item.add_meta_list, welfare_amenities: item.welfare_amenities, branches: item.branches});
      })
    }
    setLandTypes(landtypesData);
  }

  const getExtraMeta = (data) => {
    if(data.add_meta_list) {
      setLandTypesMeta(data.add_meta_list);
    } 
    if(data.welfare_amenities) {
      setLandTypesWelfareAmenities(data.welfare_amenities);
    }
    if(data.branches) {
      setLandTypesBranches(data.branches);
    }
  }

  const stepRender = (step) => {
    switch (step) {
      case 1:
        return (
          <View key={1}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>اطلاعات اولیه</Text>
            <Controller
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="اشتراک آگهی"
                  placeholder="جستجو کارشناس مورد نظر"
                  options={experts}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.expert_ids}
                  onValueChange={onChange}
                  onSelect={(data) => {}}
                  multiple
                />
              )}
              name="expert_ids"
            />
            <Controller
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="توضیحات آگهی"
                  placeholder="درصورت وجود، توضیحات آگهی را وارد کنید"
                  mode="outlined"
                  activeOutlineColor="#c6c5c4"
                  style={{ marginBottom: 24, fontSize: 14 }}
                  multiline
                  numberOfLines={4}
                  error={errors.description}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  defaultValue={value}
                />
              )}
              name="description"
            />
            <Controller
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="یادداشت خصوصی"
                  placeholder="درصورت وجود، یادداشت خصوصی را وارد کنید"
                  mode="outlined"
                  activeOutlineColor="#c6c5c4"
                  style={{ marginBottom: 24, fontSize: 14 }}
                  multiline
                  numberOfLines={4}
                  error={errors.expertDescription}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  defaultValue={value}
                />
              )}
              name="expertDescription"
            />
            <Controller
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10, gap: 6 }}>
                  <Text style={{ width: 70, fontSize: 16 }}>فوری</Text>
                  <Switch value={value} onValueChange={onChange} />
                </View>
              )}
              name="urgent"
            />
            <Controller
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10, gap: 6 }}>
                  <Text style={{ width: 70, fontSize: 16 }}>لوکس</Text>
                  <Switch value={value} onValueChange={onChange} />
                </View>
              )}
              name="lux"
            />
            <Controller
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10, gap: 6 }}>
                  <Text style={{ width: 70, fontSize: 16 }}>اوکازیون</Text>
                  <Switch value={value} onValueChange={onChange} />
                </View>
              )}
              name="occasion"
            />
            <Controller
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 10, gap: 6 }}>
                  <Text style={{ width: 70, fontSize: 16 }}>قابل معاوضه</Text>
                  <Switch value={value} onValueChange={onChange} />
                </View>
              )}
              name="exchange"
            />
            <Controller
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <View style={{ flexDirection: 'row', alignItems: 'center', marginBottom: 0, gap: 6 }}>
                  <Text style={{ width: 70, fontSize: 16 }}>زیر قیمت</Text>
                  <Switch value={value} onValueChange={onChange} />
                </View>
              )}
              name="underPrice"
            />
          </View>
        );
      break;
      case 2:
        return (
          <View key={2}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>اطلاعات منطقه</Text>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="آدرس ملک"
                  placeholder="آدرس ملک را بصورت دقیق وارد کنید"
                  mode="outlined"
                  activeOutlineColor="#c6c5c4"
                  style={{ marginBottom: 24, fontSize: 14 }}
                  multiline
                  numberOfLines={4}
                  error={errors.address}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  value={value}
                />
              )}
              name="address"
            />
            {/* <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="کشور"
                  placeholder="جستجو کشور مورد نظر"
                  options={countries}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.region?.country}
                  onValueChange={onChange}
                  onSelect={(data) => getState(data.key)}
                />
              )}
              name="region[country]"
            />
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="استان"
                  placeholder="جستجو استان مورد نظر"
                  options={ostan}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.region?.ostan}
                  onValueChange={onChange}
                  onSelect={(data) => getShahrestans(data.key)}
                />
              )}
              name="region[ostan]"
            />
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="شهرستان"
                  placeholder="جستجو شهرستان مورد نظر"
                  options={shahrestan}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.region?.shahrestan}
                  onValueChange={onChange}
                  onSelect={(data) => getMantaghe(data.key)}
                />
              )}
              name="region[shahrestan]"
            /> */}
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="منطقه"
                  placeholder="جستجو منطقه مورد نظر"
                  options={mantaghe}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.region?.mantaghe}
                  onValueChange={onChange}
                  onSelect={(data) => getBakhsh(data.key)}
                />
              )}
              name="region[mantaghe]"
            /> 
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="بخش"
                  placeholder="جستجو بخش مورد نظر"
                  options={bakhsh}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.region?.bakhsh}
                  onValueChange={onChange}
                  onSelect={(data) => {}}
                />
              )}
              name="region[bakhsh]"
            />
          </View>
        );
      break;
      case 3:
        return (
          <View key={3}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>اطلاعات مالک</Text>
            <Button onPress={() => Keyboard.dismiss()}>125</Button>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="نام مالک"
                  placeholder="نام مالک را بدون نوشتن آقا/خانم وارد کنید"
                  mode="outlined"
                  activeOutlineColor="#c6c5c4"
                  style={{ marginBottom: 24, fontSize: 14 }}
                  error={errors.malekName}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  value={value}
                />
              )}
              name="malekName"
            />
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="شماره مالک"
                  placeholder="شماره مالک را بصورت دقیق وارد کنید"
                  mode="outlined"
                  activeOutlineColor="#c6c5c4"
                  style={{ marginBottom: 24, fontSize: 14 }}
                  error={errors.phone}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  defaultValue={value}
                  keyboardType='number-pad'
                />
              )}
              name="phone"
              defaultValue={''}
            />
            <Controller
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="نام نماینده"
                  placeholder="نام نماینده را بدون نوشتن آقا/خانم وارد کنید"
                  mode="outlined"
                  activeOutlineColor="#c6c5c4"
                  style={{ marginBottom: 24, fontSize: 14 }}
                  error={errors.nemayande_name}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  defaultValue={value}
                />
              )}
              name="nemayande_name"
              defaultValue={''}
            />
            <Controller
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <TextInput
                  label="شماره نماینده"
                  placeholder="شماره نماینده را بصورت دقیق وارد کنید"
                  mode="outlined"
                  activeOutlineColor="#c6c5c4"
                  style={{ marginBottom: 24, fontSize: 14 }}
                  error={errors.nemayande_phone}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  defaultValue={value}
                />
              )}
              name="nemayande_phone"
              defaultValue={''}
            />
          </View>
        );
      break;
      case 4:
        return (
          <View key={4}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>دسته بندی‌ها</Text>
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="نوع معامله"
                  placeholder="جستجو نوع معامله مورد نظر"
                  options={transactions}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.transaction}
                  onValueChange={onChange}
                  onSelect={(data) => {getSellStatus(data); setTransactionId(data?.key)}}
                />
              )}
              name="transaction"
            />
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="کاربری ملک"
                  placeholder="جستجو کاربری ملک مورد نظر"
                  options={sellStatus}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.sell_status}
                  onValueChange={onChange}
                  onSelect={(data) => getLandType(data)}
                />
              )}
              name="sell_status"
            />
            <Controller
              control={control}
              rules={{
                required: true,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label="نوع ملک"
                  placeholder="جستجو نوع ملک مورد نظر"
                  options={landTypes}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors.land_type}
                  onValueChange={onChange}
                  onSelect={(data) => getExtraMeta(data)}
                />
              )}
              name="land_type"
            />
          </View>
        );
      break;
      case 5:
        return (
          <View key={5}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>اطلاعات ملک</Text>
            {Object.keys(transactionsMeta).length > 0 && Object.values(transactionsMeta).map(item => renderFormItems(item))}
            {Object.keys(landTypesMeta).length > 0 && Object.values(landTypesMeta).map(item => renderFormItems(item, transactionId))}
          </View>
        );
      break;
      case 6:
        return (
          <View key={6}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>امکانات رفاهی</Text>
            {Object.keys(landTypesWelfareAmenities).length > 0 && Object.values(landTypesWelfareAmenities).map(item => renderFormItems(item))}
          </View>
        );
      break;
      case 7:
        return (
          <View key={7}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 20, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>انشعابات</Text>
            {Object.keys(landTypesBranches).length > 0 && Object.values(landTypesBranches).map(item => renderFormItems(item))}
          </View>
        );
      break;
      case 8:
        return (
          <View key={8}>
            <Text style={{ fontSize: 16, color: '#292D32', marginBottom: 6, fontFamily: 'IRANSans_Medium', textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>گالری تصاویر</Text>
            <Text style={{ fontSize: 12, color: '#5B5E63', marginBottom: 20, textAlign: Platform.OS === 'web' ? 'right' : 'left' }}>اولین عکس به عنوان عکس اصلی در نظر گرفته میشود.</Text>
            <Controller
              control={control}
              rules={{
                required: false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <ImageUploader onChange={onChange} value={value} />
              )}
              name="image_gallery"
            />
          </View>
        );
      break;
    }
  }

  const renderFormItems = (data, id = null) => {    
    if((id == '654f53b259bf02158abba670') && (data.id == 'changeable')) {
      return '';
    } else if((id == '654f53b259bf02158abba670') && (data.id == 'loan')) {
        return '';
    } else if((id == '654f53b259bf02158abba670') && (data.id == 'mablaghe_vam')) {
        return '';
    } else {
      switch (data.type) {
        case 'number':
          return (
            <Controller
              control={control}
              rules={{
                required: data.required === 'on' ? true : false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <NumberTextInput
                  label={data.label}
                  placeholder={`${data.label} ملک مورد نظر را وارد کنید`}
                  mode="outlined"
                  activeOutlineColor="#c6c5c4"
                  style={{ marginBottom: 24, fontSize: 14 }}
                  error={errors[data.id]}
                  onBlur={onBlur}
                  onChangeText={onChange}
                  value={value}
                  keyboardType='number-pad'
                />
              )}
              name={data.id}
              defaultValue={data.value}
            />
          );
        break;
        case 'text':
            return (
              <Controller
                control={control}
                rules={{
                  required: data.required === 'on' ? true : false,
                }}
                render={({ field: { onChange, onBlur, value } }) => (
                  <TextInput
                    label={data.label}
                    placeholder={`${data.label} ملک مورد نظر را وارد کنید`}
                    mode="outlined"
                    activeOutlineColor="#c6c5c4"
                    style={{ marginBottom: 24, fontSize: 14 }}
                    error={errors[data.id]}
                    onBlur={onBlur}
                    onChangeText={onChange}
                    defaultValue={value}
                  />
                )}
                name={data.id}
                defaultValue={data.value}
              />
            );
        break;
        case 'select':
          let options = [];
          if(data.choices && Object.keys(data.choices).length > 0) {
            Object.values(data.choices).map((item, i) => {
              options.push({key: item.id, value: item.label});
            })
          }
          return (
            <Controller
              control={control}
              rules={{
                required: data.required === 'on' ? true : false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Select
                  label={data.label}
                  placeholder={`${data.label} ملک مورد نظر را وارد کنید`}
                  options={options}
                  selectedValue={value}
                  onBlur={onBlur}
                  error={errors[data.id]}
                  onValueChange={onChange}
                  onSelect={(data) => {}}
                  multiple={true}
                />
              )}
              name={data.id}
              defaultValue={data.value}
            />
          );
        break;
        case 'on-off':
          return (
            <Controller
              control={control}
              rules={{
                required: data.required === 'on' ? true : false,
              }}
              render={({ field: { onChange, onBlur, value } }) => (
                <Checkbox onChange={onChange} onBlur={onBlur} value={value} label={data.label} />
              )}
              name={data.id}
              defaultValue={data.value}
            />
          );
        break;
      }
    }
  }

  const validateNextStep = (data) => {
    myContext.setAddAdsForm(data);
    if(step === 8) {
      formSubmit(data);
    } else {
      setStep(step + 1);
    }
  }

  const formSubmit = (values) => {
    setSubmitLoading(true);
    Object.keys(values).forEach(key => values[key] === undefined ? delete values[key] : {});
    axios.all([
      axios.post(`/panel/ads/add`, values),
    ])
      .then(axios.spread((response) => {
        if(response.data.success === true) {
          myContext.activateSnackbar(true, 'آگهی مورد نظر با موفقیت ثبت شد'); 
          router.replace('/myAds');
        }
        if(response.data.success === false) {
          myContext.activateSnackbar(true, response.data.message);
        }
        if(response.data.error) {
          
        }
      }))
      .catch(myContext.handleAxiosError)
      .finally(() => setSubmitLoading(false));
  }

  const onRemoveLastForm = () => {
    setAddAdsFormActive(false);
    reset({});
    myContext.setAddAdsForm({});
    myContext.setAddAdsFormActive(false);
    setStep(1);
  }

  if(pageLoading) {
    return (
      <MotiView
        transition={{
          type: 'timing',
        }}
        style={{ flex: 1, justifyContent: 'space-between', paddingVertical: 16, paddingHorizontal: 18 }}
        animate={{ backgroundColor: colorScheme === 'dark' ? '#000000' : '#ffffff' }}
      >
        <View>
          <Skeleton colorMode={colorScheme} width={250} />
          <Spacer height={24} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={48} />
          <Spacer height={24} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={48} />
          <Spacer height={24} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={48} />
          <Spacer height={24} />
          <Skeleton colorMode={colorScheme} width={'100%'} height={48} />
        </View>
        <Skeleton colorMode={colorScheme} width={'100%'} height={48} />
      </MotiView>
    );
  } else {
    return (
      <>
        {
          addAdsFormActive ?
            <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center', backgroundColor: '#fcfcfd', paddingHorizontal: 18 }}>
              <Image source={HaveForm} style={{ width: 178, height: 142 }} />
              <Text style={{ fontSize: 16, color: '#656564', marginBottom: 50, textAlign: 'center', fontFamily: 'IRANSans_Medium' }}>شما فرم تکمیل نشده دارید!</Text>
              <View style={{ width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                <Button labelStyle={{ fontSize: 16 }} style={{ width: '70%', borderRadius: 48, backgroundColor: '#2B93F3', marginBottom: 8 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained" onPress={() => setAddAdsFormActive(false)}>ادامه دادن</Button>
                <Button labelStyle={{ fontSize: 16, color: '#3F3E3D' }} style={{ width: '70%', borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="text" onPress={onRemoveLastForm}>حذف</Button>
              </View>
            </View>
          :
            <View style={{ flex: 1, justifyContent: 'space-between', backgroundColor: '#fcfcfd', paddingTop: 16 }}>
              <View style={styles.stepContiner}>
                <View style={styles.stepLine} />
                <View style={step === 1 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 1 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
                <View style={step === 2 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 2 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
                <View style={step === 3 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 3 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
                <View style={step === 4 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 4 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
                <View style={step === 5 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 5 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
                <View style={step === 6 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 6 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
                <View style={step === 7 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 7 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
                <View style={step === 8 ? styles.stepItem : styles.stepItemDeActive}><View style={step === 8 ? styles.stepItemDot : styles.stepItemDotDeActive} /></View>
              </View>
              <ScrollView style={styles.stepContentContiner} contentContainerStyle={{ paddingHorizontal: 18, paddingTop: 8 }}>
                {stepRender(step)}
              </ScrollView>
              <View style={styles.stepButtons}>
                {step > 1 && <Button labelStyle={{ fontSize: 16, color: '#3F3E3D' }} style={{ width: '48%', marginTop: 36, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="outlined" onPress={() => setStep(step - 1)}>قبلی</Button>}
                {
                  step === 8 ?
                    <Button loading={submitLoading} disabled={submitLoading} labelStyle={{ fontSize: 16 }} style={{ width: step > 1 ? '48%' : '100%', marginTop: 36, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained" onPress={handleSubmit(validateNextStep)}>ثبت آگهی</Button>
                  :
                    <Button labelStyle={{ fontSize: 16 }} style={{ width: step > 1 ? '48%' : '100%', marginTop: 36, borderRadius: 48 }} contentStyle={{ height: 48, paddingTop: 5 }} mode="contained" onPress={handleSubmit(validateNextStep)}>بعدی</Button>
                }
              </View>
            </View>
        }
      </>
    );
  }
}

const styles = StyleSheet.create({
  shape: {
    justifyContent: 'center',
    height: 250,
    width: 250,
    borderRadius: 25,
    marginRight: 10,
    backgroundColor: 'white',
  },
  stepContiner: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 18
  },
  stepLine: {
    width: '100%',
    height: 2,
    backgroundColor: '#D1D5DB',
    position: 'absolute',
    top: '50%',
    marginHorizontal: 18
  },
  stepItem: {
    width: 24,
    height: 24,
    backgroundColor: '#fcfcfd',
    borderWidth: 2,
    borderColor: '#FF0000',
    borderRadius: 24,
    justifyContent: 'center',
    alignItems: 'center'
  },
  stepItemDeActive: {
    width: 24,
    height: 24,
    backgroundColor: '#fcfcfd',
    borderWidth: 2,
    borderColor: '#D1D5DB',
    borderRadius: 24,
    justifyContent: 'center',
    alignItems: 'center'
  },
  stepItemDot: {
    width: 8,
    height: 8,
    backgroundColor: '#FF0000',
    borderRadius: 8
  },
  stepItemDotDeActive: {
    width: 8,
    height: 8,
    backgroundColor: '#fcfcfd',
    borderRadius: 8
  },
  stepContentContiner: {
    flex: 1,
    width: '100%',
    marginTop: 24,
  },
  stepButtons: {
    width: '100%',
    flexDirection: 'row', 
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBottom: 32,
    paddingHorizontal: 18
  }
});
